import React from 'react';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';

/**
 * Forgot password page wrapper component
 * Combines AuthLayout with ForgotPasswordForm
 */
const ForgotPasswordPage: React.FC = () => {
  return (
    <AuthLayout
      title="Reset Password"
      subtitle="Get back into your account"
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;